import { API_BASE_URL } from '../config/api';

export type GoogleAuthIntent = 'auto' | 'landlord' | 'tenant';
export type GoogleAuthMode = 'login' | 'signup';

export interface GoogleSignupProfile {
  firstName?: string;
  lastName?: string;
  phone?: string;
  accountType?: 'LANDLORD' | 'MANAGEMENT_FIRM';
  country?: string;
}

export interface GoogleAuthApiResult {
  token: string;
  accountKind: 'landlord' | 'tenant';
  isNewUser: boolean;
  mustVerifyPhone: boolean;
  mustChangePassword: boolean;
  needsDeposit?: boolean;
  depositPaymentToken?: string | null;
  user: {
    id: string;
    email: string;
    role: string | null;
    accountStatus: string;
    phoneVerified: boolean;
    displayName?: string | null;
    tenantProfileId?: string | null;
  };
  message?: string;
}

export async function postGoogleAuth(params: {
  credential: string;
  mode: GoogleAuthMode;
  intent?: GoogleAuthIntent;
  profile?: GoogleSignupProfile;
}): Promise<GoogleAuthApiResult> {
  const res = await fetch(`${API_BASE_URL}/auth/google`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err: any = new Error(data.error || 'Google sign-in failed');
    err.code = data.code;
    err.depositPaymentToken = data.depositPaymentToken;
    throw err;
  }
  return data as GoogleAuthApiResult;
}
